export const ActionTypes = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
}

export const toggle = (key: string, show: boolean) => {
  return {
    type: show ? ActionTypes.SHOW : ActionTypes.HIDE,
    key,
  }
}
